import { Injectable } from '@angular/core';
import { EntityService, HttpClient } from '@elotech/angular-common';
import { Observable } from 'rxjs';

import { EnumItem } from '../common/enum-item';


@Injectable()
export class CentralPortalServidorService extends EntityService<any> {

  constructor(public httpClient: HttpClient) {
    super(httpClient);
    this.resource = '/api/central-portal-servidor';
  }

  public popularGruposHabilitadosData(): Observable<CentralPortalServidor[]> {
    return this.httpClient.get({
      disableSpinner: true,
      resource: `${this.resource}/popular-grupos-habilitados`,
    });
  }

  public verificarConflitosPorDatas(dataInicial: Date, dataFinal: Date, id: number, grupo: String): Observable<boolean> {
    let temp: string = '';
    if (id) {
      temp += '&id=' + id;
    }
    if (dataFinal) {
      temp += '&dataFinal=' + dataFinal;
    }
    return this.httpClient.get({
      disableSpinner: true,
      resource: `${this.resource}/verificar-conflito-datas?dataInicial=${dataInicial}&grupo=${grupo}${temp}`,
    });
  }

  public hasHoleriteLiberacaoMonitoradaHabilitado(competenciaId: number): Observable<boolean> {
    return this.httpClient.get({
      resource: `${this.resource}/holerite-liberacao-habilitado/${competenciaId}`,
    });
  }
}


export interface CentralPortalServidor {
  id: number,
  entidade: number,
  grupoPortalServidor: EnumItem,
  habilitado: boolean,
  dataInicial: string,
  dataFinal: string
}
